import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import Dropdown from '../../../components/dropdown'
import { filterSortByOptions } from '../../../../common/utils/item'
import siteDefaultConfigs from '../../../../config/sites/defaults'
import { parseLocation, makeLink } from '../../../../common/utils/urlHelper'

const searchQueryConfigs = siteDefaultConfigs['search_query']
const defaultSortByOptions = searchQueryConfigs['defalut_sort_by_options']

/**
 * A sort by menu which has lots of business logic
 */
class SortByDropdown extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    currentSite: PropTypes.string.isRequired
  }

  constructor (props) {
    super(props)
    this.onSortBySelectionChange = this.onSortBySelectionChange.bind(this)
  }

  getSelectSortByValue (parsedLocation) {
    if (parsedLocation.sort_by) {
      if (parsedLocation.sort_by === 'price' &&
        parsedLocation.sort_direction) {
        return 'price-' + parsedLocation.sort_direction
      } else {
        return parsedLocation.sort_by
      }
    } else {
      return parsedLocation.term ? 'relevance' : 'date'
    }
  }

  onSortBySelectionChange (event) {
    const {
      location
    } = this.props

    const parsedLocation = parseLocation(location)

    let sort = event.target.value
    let newQuery = Object.assign({}, parsedLocation, {
      sort
    })
    delete newQuery.sort_by
    delete newQuery.sort_direction

    this.props.history.push(makeLink(newQuery))
  }

  render () {
    const {
      location,
      currentSite
    } = this.props

    const parsedLocation = parseLocation(location)

    const sortByOptions = filterSortByOptions(currentSite, parsedLocation, defaultSortByOptions)

    // Append "Sort by:" to selected label
    const sortByOptionsWithLabel = sortByOptions.map((option) => {
      if (option.value === this.getSelectSortByValue(parsedLocation)) {
        return Object.assign({}, option, {
          label: `Sort by: ${option.label}`
        })
      } else {
        return option
      }
    })

    return (
      <div className='inline-select-wrapper'>
        <div className='search-facet-header--horizontal'>
          <h2>
            <i className='e-icon -icon-sort -margin-right' />
            <span className='e-icon__alt'>Sort by</span>
          </h2>
        </div>
        <div className='-border-top-none -border-radius-none inline-select'>
          <label htmlFor='sortby' className='fds-u-is-visually-hidden'>Sort by: </label>
          <Dropdown
            name='sortby'
            options={sortByOptionsWithLabel}
            onChange={this.onSortBySelectionChange}
            value={this.getSelectSortByValue(parsedLocation)} />
        </div>
      </div>
    )
  }
}

export default withRouter(SortByDropdown)



// WEBPACK FOOTER //
// ./client/pages/search/result/sortByDropdown.js